import Vue from 'vue';

Vue.component('custom-receipt-index', () =>
    import(/* webpackChunkName: 'custom-receipt-index' */ './custom-receipt-index.vue'),
);
